import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { PermitDocument } from "../../../types/permits";
import Resources from "../../../types/Resources";
import InformationAlert from "../../Common/InformationAlert";
import TextArea from "../../Common/TextArea";
import Button from "../../Common/Button";

type UpdateWithNotificationModalProps = {
    show: boolean;
    permitDocument: (PermitDocument & { anonymousUserEmail: string }) | undefined;
    onHide: () => void;
    resources: Resources;
    onUpdate: (updateComment: string) => void;
};

function UpdateWithNotificationModal({
    show,
    permitDocument,
    onHide,
    resources,
    onUpdate
}: UpdateWithNotificationModalProps) {
    const [comment, setComment] = useState("");

    if (!permitDocument) {
        return null;
    }

    const disableUpdateButton = !comment;

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("UpdateWithNotificationHeader")}</h1>
            </Modal.Header>
            <Modal.Body>
                <InformationAlert>
                    <span>{resources.get("UpdateWithNotificationInfo")}</span>{" "}
                    <span>{permitDocument.anonymousUserEmail}</span>
                </InformationAlert>

                <TextArea
                    errorMessage=""
                    labelText={resources.get("Comment")}
                    onChange={setComment}
                    value={comment}
                    textAreaId="update-with-notification-comment"
                    containerClassName="mt-5"
                    readOnly={false}
                />

                <Button onClick={() => onUpdate(comment)} disabled={disableUpdateButton} className="mt-3">
                    {resources.get("Update")}
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default UpdateWithNotificationModal;
